import * as React from 'react'
import './style.scss'

interface IProps {
  text: string
  buttonRight?: any
}

export class PageTitle extends React.PureComponent<IProps> {
  render() {
    const { text, buttonRight } = this.props
    return (
      <div className="page-title">
        <div className="page-title-text">{text}</div>
        {buttonRight && (
          <div className="page-title-button-right">{buttonRight}</div>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/PageTitle/index.tsx